module.exports = __webpack_public_path__ + "img/theme1.66072711.png";